<template>
  <div class="fill-width">
    <b-container class="m-0 p-0" fluid v-if="getMobileLayout">
      <b-row class="mx-1">
        <b-col
          cols="12"
          class="pt-2 d-flex justify-content-center align-items-center"
        >
          <span class="text-center new-title-color font-size-medium-small">
            {{ $translate("shopName") }}: {{ $translate("caspianPay") }}
          </span>
        </b-col>
        <b-col
          cols="12"
          class="text-center new-subtext-color pt-2 font-size-small pb-3 border-bottom-light-gray-2px-dashed"
        >
          {{ $translate("timeRemaining") }}:

          <strong class="red-text">
            <Timer
              ref="Transaction"
              :spanClass="'alert-text'"
              :duration="360000"
              :timerKey="'Transaction'"
              @expired="expiredTransactionTimerAction"
            />
          </strong>
        </b-col>
      </b-row>
      <b-row class="font-size-small pt-2">
        <b-col cols="6"
          ><span class="new-subtext-color"
            >{{ $translate("amountToPay") }}:</span
          ></b-col
        >
        <b-col cols="6" class="text-start"
          ><span class="green-text font-weight-bold"
            >{{ getShaparakPayingAmount | commaSep | persianDigit }}
            {{ $translate("toman") }}</span
          >
        </b-col>
      </b-row>
      <b-container class="mt-1 p-2 mb-3">
        <b-row>
          <b-col
            cols="12"
            class="pb-1 new-title-color font-weight-bold font-size-small"
          >
            {{ $translate("cardNumber") }}:
          </b-col>
          <b-col cols="12" class="pb-1 new-subtext-color font-size-xs"
            >{{ $translate("enter16DigitCardNumber") }}
          </b-col>
        </b-row>
        <b-row class="direction-ltr m-0 pb-3">
          <div class="input-group p-0">
            <div class="input-group-prepend">
              <span class="input-group-text fill-height border-none">
                <img
                  :src="bankImageSource"
                  height="25"
                  width="25"
                  v-if="checkIfInputNotEmpty"
                />
              </span>
            </div>
            <input
              v-for="(key, i) in fixShaparakCreditCardNumber"
              :value="fixShaparakCreditCardNumber[i].value"
              :key="+i"
              readonly
              class="col-2 form-control new-form-control mx-1"
            />
          </div>
        </b-row>
        <b-row class="pb-4">
          <b-col cols="12" class="new-title-color font-size-small pb-1">
            <span class="font-weight-bold">{{ $translate("cvv2Title") }}</span>
            <span>(cvv2)</span>
          </b-col>
          <b-col cols="12" class="pb-1 new-subtext-color font-size-xs"
            >{{ $translate("enterCvv2CodeInsertedIntoYourCard") }}
          </b-col>
          <b-col cols="12">
            <b-form-input
              placeholder="####"
              class="form-control new-form-control"
              type="text"
              pattern="\d*"
              inputmode="numeric"
              autocomplete="cvv2"
              v-mask="'####'"
              mask="false"
              v-model="creditCardCVV2"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            class="new-title-color font-size-small pb-1 font-weight-bold"
          >
            {{ $translate("cardExpireTime") }}:
          </b-col>
          <b-col cols="12" class="pb-1 new-subtext-color font-size-xs"
            >{{ $translate("enterTheMonthAndYearOfCardExpiration") }}
          </b-col>
        </b-row>

        <b-row class="new-subtext-color m-0 pb-3">
          <b-col cols="6" class="pr-0 pl-0point5">
            <b-form-input
              class="new-form-control"
              id="expireDateMonthInput"
              :placeholder="$translate('month')"
              pattern="\d*"
              inputmode="numeric"
              v-mask="'##'"
              mask="false"
              v-model="creditCardExpireDateMonth"
              :state="creditCardMonthExpireValidation"
            ></b-form-input>
          </b-col>
          <b-col cols="6" class="pl-0 pr-0point5">
            <b-form-input
              class="new-form-control"
              id="expireDateYearInput"
              :placeholder="$translate('year')"
              pattern="\d*"
              inputmode="numeric"
              v-mask="'##'"
              mask="false"
              v-model="creditCardExpireDateYear"
              :state="creditCardMonthExpireValidation"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="pb-3">
          <b-col
            cols="12"
            class="new-title-color font-size-small pb-1 font-weight-bold"
          >
            {{ $translate("cardSecondInternetPassword") }}:
          </b-col>
          <b-col cols="12" class="pb-1 new-subtext-color font-size-small"
            >{{ $translate("enterTheSentPooyaPassword") }}
          </b-col>
          <b-row class="pl-0">
            <b-col cols="8" class="pl-0">
              <b-form-input
                id="creditCardPasswordInput"
                class="form-control new-form-control"
                type="password"
                pattern="\d*"
                inputmode="numeric"
                v-mask="'########'"
                mask="false"
                v-model="creditCardPassword"
              ></b-form-input>
            </b-col>
            <b-col cols="4" class="pl-0">
              <button
                class="password-request-button password-request-font-size-lg"
                v-if="!passwordRequestSend && !passwordRequestPending"
                @click="getCreditCardPass()"
              >
                <span class="font-weight-bold dynamic-font-size">{{
                  $translate("receivePassword")
                }}</span>
              </button>
              <button
                class="password-request-button password-request-font-size-lg"
                v-else
              >
                <div
                  v-if="passwordRequestPending && !passwordRequestSend"
                  class="spinner-border text-dark"
                  style="width: 0.9rem; height: 0.9rem"
                ></div>
                <span v-if="passwordRequestSend" class="text-white">
                  <Timer
                    ref="PasswordRequest"
                    :spanClass="'text-white'"
                    :duration="120000"
                    :timerKey="'PasswordRequest'"
                    @expired="expiredPasswordRequestAction"
                  />
                </span>
              </button>
            </b-col>
          </b-row>
        </b-row>
        <b-row class="pb-4">
          <b-col cols="4">
            <button type="button" class="new-version-decline-button">
              <span class="button-texts">
                {{ $translate("cancel") }}
              </span>
            </button>
          </b-col>
          <b-col cols="8">
            <button
              type="button"
              class="go-to-next-button"
              @click="finalTransferShaparakSubmit"
            >
              <b-row class="fill-width">
                <b-col cols="10"
                  ><span class="button-texts">
                    {{ $translate("nextStep") }}</span
                  ></b-col
                >
                <b-col cols="2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    class="bi bi-arrow-left-short"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                    />
                  </svg>
                </b-col>
              </b-row>
            </button>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
    <b-container class="m-0 p-0" fluid v-else-if="!getMobileLayout">
      <b-row>
        <b-col
          :cols="getSmallDesktopMonitor ? 12 : 8"
          align-self="center"
          class="d-flex justify-content-center"
        >
          <b-row class="fill-width py-3">
            <b-col
              :cols="getSmallDesktopMonitor ? 7 : 6"
              md="7"
              class="d-flex justify-content-center"
            >
              <b-row class="fill-width">
                <b-col
                  cols="12"
                  class="d-flex align-items-center pb-1 new-title-color font-weight-bold font-size-small"
                >
                  {{ $translate("cardNumber") }}:
                </b-col>
                <b-col
                  cols="12"
                  class="d-flex align-items-center pb-3 new-subtext-color font-size-xs"
                  >{{ $translate("enter16DigitCardNumber") }}
                </b-col>
                <b-col
                  cols="12"
                  class="d-flex align-items-center justify-content-center"
                >
                  <b-row class="direction-ltr m-0 pb-3">
                    <div class="input-group p-0">
                      <div class="input-group-prepend">
                        <span class="input-group-text fill-height border-none">
                          <img
                            :src="bankImageSource"
                            height="25"
                            width="25"
                            v-if="checkIfInputNotEmpty"
                          />
                        </span>
                      </div>
                      <input
                        v-for="(key, i) in fixShaparakCreditCardNumber"
                        :value="fixShaparakCreditCardNumber[i].value"
                        :key="+i"
                        placeholder="1234"
                        readonly
                        class="col-2 form-control new-form-control mx-1"
                      />
                    </div>
                  </b-row>
                </b-col>
                <b-col cols="12">
                  <b-row class="pb-4">
                    <b-col
                      cols="12"
                      class="d-flex align-items-center new-title-color font-size-small pb-1"
                    >
                      <span class="font-weight-bold">{{
                        $translate("cvv2Title")
                      }}</span>
                      <span>(cvv2)</span>
                    </b-col>
                    <b-col cols="12" class="pb-3 new-subtext-color font-size-xs"
                      >{{ $translate("enterCvv2CodeInsertedIntoYourCard") }}
                    </b-col>
                    <b-col cols="12">
                      <b-form-input
                        placeholder="####"
                        class="form-control new-form-control"
                        type="text"
                        pattern="\d*"
                        inputmode="numeric"
                        autocomplete="cvv2"
                        v-mask="'####'"
                        mask="false"
                        v-model="creditCardCVV2"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
            <b-col
              :cols="getSmallDesktopMonitor ? 5 : 6"
              md="5"
              class="d-flex justify-content-center"
            >
              <b-row>
                <b-col
                  cols="12"
                  class="d-flex align-items-center new-title-color font-size-small pb-1 font-weight-bold"
                >
                  {{ $translate("cardExpireTime") }}:
                </b-col>
                <b-col cols="12" class="pb-3 new-subtext-color font-size-xs"
                  >{{ $translate("enterTheMonthAndYearOfCardExpiration") }}
                </b-col>
                <b-col cols="12" class="d-flex align-items-center">
                  <b-row class="new-subtext-color m-0 pb-3">
                    <b-col cols="6" class="pr-0 pl-0point5">
                      <b-form-input
                        class="new-form-control"
                        id="expireDateMonthInput"
                        :placeholder="$translate('month')"
                        pattern="\d*"
                        inputmode="numeric"
                        v-mask="'##'"
                        mask="false"
                        v-model="creditCardExpireDateMonth"
                        :state="creditCardMonthExpireValidation"
                      ></b-form-input>
                    </b-col>
                    <b-col cols="6" class="pl-0 pr-0point5">
                      <b-form-input
                        class="new-form-control"
                        id="expireDateYearInput"
                        :placeholder="$translate('year')"
                        pattern="\d*"
                        inputmode="numeric"
                        v-mask="'##'"
                        mask="false"
                        autocomplete="off"
                        v-model="creditCardExpireDateYear"
                        :state="creditCardMonthExpireValidation"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12">
                  <b-row class="pb-4">
                    <b-col
                      cols="12"
                      class="new-title-color font-size-small pb-1 font-weight-bold"
                    >
                      {{ $translate("cardSecondInternetPassword") }}:
                    </b-col>
                    <b-col
                      cols="12"
                      class="pb-3 new-subtext-color font-size-small"
                      >{{ $translate("enterTheSentPooyaPassword") }}
                    </b-col>
                    <b-row class="pl-0 d-flex justify-content-md-center">
                      <b-col cols="8" md="12" xl="8" lg="7" class="pl-0">
                        <b-form-input
                          id="creditCardPasswordInput"
                          class="form-control new-form-control"
                          type="password"
                          pattern="\d*"
                          inputmode="numeric"
                          v-mask="'########'"
                          mask="false"
                          v-model="creditCardPassword"
                        ></b-form-input>
                      </b-col>
                      <b-col
                        cols="4"
                        md="6"
                        xl="4"
                        lg="5"
                        class="d-flex justify-content-center align-items-center pl-0 mt-md-2 mt-lg-0"
                      >
                        <button
                          class="password-request-button password-request-font-size-lg"
                          v-if="!passwordRequestSend && !passwordRequestPending"
                          @click="getCreditCardPass()"
                        >
                          <span class="font-weight-bold dynamic-font-size">{{
                            $translate("receivePassword")
                          }}</span>
                        </button>
                        <button
                          class="password-request-button password-request-font-size-lg"
                          v-else
                        >
                          <div
                            v-if="
                              passwordRequestPending && !passwordRequestSend
                            "
                            class="spinner-border text-dark"
                            style="width: 0.9rem; height: 0.9rem"
                          ></div>
                          <span v-if="passwordRequestSend" class="text-white">
                            <Timer
                              ref="PasswordRequest"
                              :spanClass="'text-white'"
                              :duration="120000"
                              :timerKey="'PasswordRequest'"
                              @expired="expiredPasswordRequestAction"
                            />
                          </span>
                        </button>
                      </b-col>
                    </b-row>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          :cols="getSmallDesktopMonitor ? 12 : 4"
          align-self="center"
          class="d-flex justify-content-center"
        >
          <b-row class="mx-1 fill-width">
            <b-container
              class="m-0 p-0 border-dashed-light-grey border-radius-10px pb-2"
              fluid
            >
              <b-col
                cols="12"
                class="pt-2 d-flex justify-content-center align-items-center"
              >
                <span
                  class="text-center new-title-color font-size-medium-small"
                >
                  {{ $translate("shopName") }}: {{ $translate("caspianPay") }}
                </span>
              </b-col>
              <b-col
                cols="12"
                class="text-center light-grey-text pt-2 font-size-small pb-3"
              >
                {{ $translate("timeRemaining") }}:

                <strong class="red-text">
                  <Timer
                    ref="Transaction"
                    :spanClass="'red-text'"
                    :duration="300000"
                    :timerKey="'Transaction'"
                    @expired="expiredTransactionTimerAction"
                  />
                </strong>
              </b-col>
              <b-col cols="12" class="d-flex justify-content-center">
                <b-row class="font-size-small pt-2 fill-width">
                  <b-col cols="6"
                    ><span class="light-grey-text"
                      >{{ $translate("amountToPay") }}:</span
                    ></b-col
                  >
                  <b-col cols="6" class="text-start"
                    ><span class="green-text font-weight-bold"
                      >{{ getShaparakPayingAmount | commaSep | persianDigit }}
                      {{ $translate("toman") }}</span
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-container>
            <b-col cols="12">
              <b-row class="pt-3">
                <b-col cols="4" class="px-0">
                  <button type="button" class="new-version-decline-button">
                    {{ $translate("cancel") }}
                  </button>
                </b-col>
                <b-col
                  cols="8"
                  class="d-flex justify-content-center align-items-center pl-0"
                >
                  <button
                    type="button"
                    class="go-to-next-button"
                    @click="finalTransferShaparakSubmit"
                  >
                    <b-row class="fill-width">
                      <b-col cols="10" class="px-0">{{
                        $translate("nextStep")
                      }}</b-col>
                      <b-col cols="2" class="px-0">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="currentColor"
                          class="bi bi-arrow-left-short"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                          />
                        </svg>
                      </b-col>
                    </b-row>
                  </button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Timer from "@/components/Timer";
import { shaparakFinalMixin } from "@/mixins/ShaparakMixins/ShaparakFinalMixin";
import { mapGetters } from "vuex";
export default {
  name: "ShaparakFinalNewVersion",
  components: { Timer },
  mixins: [shaparakFinalMixin],
  computed: {
    ...mapGetters(["getMobileLayout", "getSmallDesktopMonitor"]),
  },
};
</script>

<style scoped>
@media only screen and (max-width: 1400px) {
  .password-request-font-size-lg {
    font-size: 0.6rem;
  }
}
@media only screen and (max-width: 1600px) and (min-width: 1400px) {
  .password-request-font-size-lg {
    font-size: 0.7rem;
  }
}
@media only screen and (max-width: 1800px) and (min-width: 1601px) {
  .password-request-font-size-lg {
    font-size: 0.8rem;
  }
}
.password-request-button {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 5px;
  background: #72d762;

  color: white;
}

::placeholder {
  text-align: center;
}

.go-to-next-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 115%;
  border: none !important;
  border-radius: 10px;
  background-color: dodgerblue;
  color: white;
}
</style>
